import React, { Component } from 'react';
import Button from '@mui/material/Button';
import authStore from '../../Auth/AuthStore'
import Loader from '../Loader'
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import './file.css'

export default class File extends Component {
    constructor(props) {
        super(props);

        this.state = {
            files: [],
            needLogin: false,
            isInLoading: false
        };

        this.myRef = React.createRef();
        this.handleFileAdd = this.handleFileAdd.bind(this);
        this.handleFileUpload = this.handleFileUpload.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }

    componentDidMount() {
        if (!this.props.workId) return;
        var scope = this;
        this.setState({ isInLoading: true });
        fetch('api/Work/GetFiles?workId=' + this.props.workId, {
            method: 'GET',
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    scope.setState({ files: result, isInLoading: false });
                }).catch((err) => console.log(err));
            }
        });
    }

    handleFileAdd() {
        this.myRef.current.click()
    }

    handleFileUpload(e) {
        this.setState({ isInLoading: true });
        var files = e.target.files;
        var token = localStorage.getItem("token");
        var data = new FormData();
        var scope = this;
        for (var i = 0; i < files.length; i++) {
            data.append('file', files.item(i));
        };

        data.append('workId', this.props.workId);
        data.append('saleId', this.props.saleId);

        fetch('api/Work/AddAttachments', {
            method: 'POST',
            body: data,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
                scope.setState({ isInLoading: false });
            }
            else {
                res.json().then((result) => {
                    scope.setState({ files: result.concat(scope.state.files), isInLoading: false });
                }).catch((err) => console.log(err));
            }
        });
    }

    handleDelete = id => evt => {
        this.setState({ isInLoading: true });
        var scope = this;
        var token = localStorage.getItem("token");
        fetch('api/Work/DeleteAttachment', {
            method: 'POST',
            body: JSON.stringify({fileId: id}),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
                scope.setState({ isInLoading: false });
            }
            else {
                if (res.status === 200) {
                    var files = scope.state.files;
                    files.splice(files.findIndex(f => f.id === id), 1);
                    scope.setState({ files: files, isInLoading: false });
                }
                else {
                    console.log(res);
                    alert('error');
                }
            }
        });
    }

    render() {
        if (this.state.isInLoading) {
            return <div><Loader /></div>
        }

        var files = this.state.files && this.state.files.map && this.state.files.map(f =>
            <div>{f.userName} {f.date} выложил/а {f.name}
                <IconButton aria-label="Удалить" onClick={this.handleDelete(f.id)} size="large">
                    <DeleteIcon />
                </IconButton>
            </div>);
        if (!this.props) {
            return <div></div>
        }
        return (
            <div>
                <input type="file" name="file" multiple hidden onChange={this.handleFileUpload} ref={this.myRef} />
                <Button variant="outlined" color="secondary" onClick={this.handleFileAdd}>Добавить</Button>
                {files}</div>
        );
    }
}
